import { READ, READ_SUCCEEDED, READ_FAILED } from "../types"

export const read = config => {
  return { type: READ, config }
}

export const readSuccess = (action, response) => {
  return { type: READ_SUCCEEDED, action, response, config: action.config }
}

export const readError = (action, error) => {
  return { type: READ_FAILED, action, error }
}
